(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('ClusterPerformanceFranchiserFormController', ClusterPerformanceFranchiserFormController)

    /** @ngInject */
    function ClusterPerformanceFranchiserFormController($state, $stateParams, HelperService, sweetAlert, ClusterPerformanceService) {
        const vm = this;
        const clusterPerformanceId = $stateParams.clusterPerformanceId;

        vm.saveClusterPerformance = () => {
            HelperService.startLoading('.loading-holder');

            if (!vm.clusterPerformanceData.Id) {
                ClusterPerformanceService
                    .post(vm.clusterPerformanceData)
                    .then(success => successCallback(success, true), errorCallback);
            } else {
                const clusterData = {
                    Id: clusterPerformanceId,
                    Name: vm.clusterPerformanceData.Name
                };

                ClusterPerformanceService
                    .put(clusterData)
                    .then(success => successCallback(success, false), errorCallback);
            }
        }

        vm.deleteClusterPerformance = () => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Não é possível desfazer essa ação!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    HelperService.startLoading('.loading-holder');

                    ClusterPerformanceService
                        .deleteClusterPerformance(clusterPerformanceId)
                        .then(() => {
                            $state.go('app.franchiser-cluster-performance-list');
                            HelperService.stopLoading('.loading-holder');
                            HelperService.successCallback('delete');
                        }, error => {
                            HelperService.errorCallback(error);
                            HelperService.stopLoading('.loading-holder');
                        });
                }
            })
        }

        init();

        function getClusterPerformance() {
            if (!clusterPerformanceId)
                return;

            HelperService.startLoading('.loading-holder');

            ClusterPerformanceService
                .get(clusterPerformanceId)
                .then(success => {
                    vm.clusterPerformanceData = success;
                    HelperService.stopLoading('.loading-holder');
                }, error => {
                    HelperService.stopLoading('.loading-holder');
                    HelperService.errorCallback(error);
                });
        }

        function successCallback(success, isPost) {
            if (isPost) {
                HelperService.successCallback();

                vm.clusterPerformanceData = success;

                $state.go('app.franchiser-cluster-performance-edit', {
                    clusterPerformanceId: vm.clusterPerformanceData.Id
                }, {
                    notify: false
                });
            }

            HelperService.successCallback('update');
            HelperService.stopLoading('.loading-holder');
        }

        function errorCallback(error) {
            HelperService.stopLoading('.loading-holder');
            HelperService.errorCallback(error);
        }

        function init() {
            vm.clusterPerformanceData = { Color: '' };

            getClusterPerformance();
        }
    }
}());